import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWrench = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon / wrench",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M5.12195 21C5.49995 21.378 6.00195 21.586 6.53595 21.586C7.06995 21.586 7.57195 21.378 7.94995 21L12.286 16.664C13.0041 16.8855 13.7514 16.9978 14.503 16.997C15.488 17 16.4638 16.8076 17.3739 16.4308C18.284 16.054 19.1103 15.5004 19.805 14.802C20.8536 13.7563 21.5685 12.4229 21.859 10.9707C22.1495 9.51846 22.0026 8.0127 21.437 6.64401L20.867 5.25601L16.623 9.49901L14.502 7.37701L18.745 3.13401L17.356 2.56301C16.4497 2.18994 15.479 1.99865 14.499 2.00001C12.496 2.00001 10.613 2.78001 9.19795 4.19601C8.23094 5.15982 7.54621 6.36995 7.21798 7.6952C6.88975 9.02046 6.93055 10.4103 7.33595 11.714L2.99995 16.05C2.62526 16.4252 2.41479 16.9338 2.41479 17.464C2.41479 17.9943 2.62526 18.5028 2.99995 18.878L5.12195 21ZM9.66995 12.209L9.41595 11.593C9.00062 10.5894 8.89256 9.48502 9.10548 8.4199C9.3184 7.35479 9.8427 6.37685 10.612 5.61001C11.1836 5.03462 11.8763 4.59383 12.6396 4.31966C13.403 4.04549 14.2178 3.94483 15.025 4.02501L11.672 7.37801L16.621 12.328L19.976 8.97301C20.0542 9.78062 19.9524 10.5955 19.678 11.3591C19.4036 12.1227 18.9634 12.8159 18.389 13.389C16.839 14.939 14.425 15.416 12.405 14.585L11.79 14.33L6.53595 19.586H6.53695L6.53595 20.586V19.586L4.41395 17.464L9.66995 12.209Z",
			fill: "black"
		})
	})
});
export default SvgWrench;
